import React, {createContext, useCallback, useEffect, useState} from "react";
import {useAppBridge} from '@shopify/app-bridge-react';
import axios from "axios";
import {getSessionToken} from "@shopify/app-bridge-utils";


export const AppContext = createContext([])


export default function AppContextProvider(props) {
    const backendUrl = props.backendUrl
    const stages = {
        exporting: '1 / 3 Searching for updated product media...',
        uploading: '2 / 3 Uploading media to Cloudinary...',
        updatingMetafields: '3 / 3 Updating metadata in Shopify...',
        nothingToDo: 'Everything is synced'
    }
    const [cldStatus, setCldStatus] = useState(null)
    const [poll, setPoll] = useState(true)
    const [syncStatus, setSyncStatus] = useState(null)
    const [shopifyState, setShopifyState] = useState(null)
    const [connectionError, setConnectionError] = useState(false);
    const app = useAppBridge();
    const serverCaller = axios.create();
// Intercept all requests on this Axios instance
        serverCaller.interceptors.request.use(function (config) {
            return getSessionToken(app) // requires a Shopify App Bridge instance
                .then((token) => {
                    // Append your request headers with an authenticated token
                    config.headers["Authorization"] = `Bearer ${token}`;
                    return config;
                });
        });

        async function postBackendUrl(url, data) {
            try {
                const ret = await serverCaller(`${backendUrl}/${url}`, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    credentials: 'include',
                    method: 'POST',
                    data: data
                })
                if (ret && ret.status === 200) {
                    return ret.data
                } else {
                    console.log(ret.status)
                    return false
                }
            } catch (e) {
                if (e.isAxiosError) {
                    let resp = e.response
                    resp.ok = false
                    return resp
                }
                return false;
            }
        }

     const getBackendUrl = useCallback(async (url) => {
        try {
            const ret = await serverCaller(`${backendUrl}/${url}`, {
                credentials: 'include',
                method: 'GET'
            })
            if (ret && ret.status === 200) {
                return  await ret.data;
            } else {
                console.log(ret.status)
                return false
            }
        } catch (e) {
            if (e.isAxiosError) {
                let resp = e.response
                resp.ok = false
                return resp
            }
            return false;
        }
    }, [serverCaller, backendUrl])

    async function getCldStatus() {
        if (process.env.REACT_APP_DEV) {
            setCldStatus(JSON.parse(process.env.REACT_APP_STORAGE_MOCK))
            return
        }
        let s = await getBackendUrl('cld/cld-status')
        if (s.ok) {
            setCldStatus(s.status)
        } else {
            if (s.status === 401) {
                setConnectionError(true)
            } else {
                setCldStatus(false)
            }
        }
    }
    useEffect(() => {
        if (cldStatus === null || cldStatus === 'get') {
                getCldStatus()
            }
        }, [cldStatus])

    async function getShopifyState() {
        if (process.env.REACT_APP_DEV) {
            setShopifyState(true)
            return
        }
        let s = await getBackendUrl('shopify/connected')
        setShopifyState(s.connected)
    }
    useEffect(() => {
        if (shopifyState === null) {
            getShopifyState()
        }
    }, [shopifyState])


        return (
            <AppContext.Provider value={{app, serverCaller, getBackendUrl, postBackendUrl, setCldStatus, cldStatus, poll, setPoll, syncStatus, setSyncStatus, stages, shopifyState, backendUrl, connectionError}}>
                {props.children}
            </AppContext.Provider>
        )
}

